import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { PROMOS, ROOBET_LINK, SOCIALS } from "../mock";

const PromoBanners = () => {
  const hrefFor = (type) => (type === "discord" ? SOCIALS.discord : ROOBET_LINK);
  const iconFor = (type) =>
    type === "discord"
      ? <img src="/assets/discord-white.png" alt="" className="w-5 h-5 object-contain mr-2" />
      : <img src="/assets/roobet-dark.png" alt="" className="w-5 h-5 object-contain mr-2" />;

  return (
    <section id="rewards" className="relative py-24 px-5">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <p className="text-[#edbb23] font-extrabold tracking-[0.3em] text-sm mb-3">REWARDS</p>
          <h2 className="text-4xl md:text-5xl font-black text-white">Exclusive Broer Perks</h2>
          <p className="mt-4 text-[#b7b0d6] max-w-xl mx-auto">
            Join the community and unlock rewards you won't find anywhere else.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-7 md:gap-8 items-stretch">
          {PROMOS.map((p) => (
            <div
              key={p.id}
              className="group relative flex flex-col h-full rounded-2xl bg-[#342b60] border border-[#473c7d] px-6 pb-7 pt-8 md:pt-20 transition-all duration-300 hover:-translate-y-2 hover:border-[#5b5baf]"
            >
              {/* floating symbol */}
              <img
                src={p.image}
                alt=""
                className="relative mx-auto mb-3 h-20 w-20 object-contain drop-shadow-2xl transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-3 md:absolute md:-top-12 md:left-1/2 md:-translate-x-1/2 md:mb-0 md:h-24 md:w-24"
              />

              {/* two-tone title */}
              <h3 className="text-center text-3xl font-black leading-tight tracking-tight mb-6">
                <span className="text-[#edbb23]">{p.title1}</span>{" "}
                <span className="text-white">{p.title2}</span>
              </h3>

              {/* checklist panel */}
              <div className="rounded-xl bg-[#251e44] border border-[#473c7d] p-5 space-y-4 mb-6 flex-1">
                {p.bullets.map((b, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <span className="mt-0.5 flex items-center justify-center w-5 h-5 rounded-full bg-[#edbb23] shrink-0">
                      <Check size={13} strokeWidth={3.5} className="text-[#251e44]" />
                    </span>
                    <span className="text-sm text-[#cfc9e8] leading-snug">{b}</span>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <a href={hrefFor(p.ctaType)} target="_blank" rel="noopener noreferrer" className="block mt-auto">
                {p.ctaType === "discord" ? (
                  <button className="w-full flex items-center justify-center bg-[#5865F2] hover:bg-[#6b77f5] text-white font-extrabold rounded-xl h-12 transition-colors">
                    {iconFor(p.ctaType)} {p.cta}
                  </button>
                ) : (
                  <button className="w-full flex items-center justify-center bg-[#edbb23] hover:bg-[#f4cf52] text-[#251e44] font-extrabold rounded-xl h-12 transition-colors">
                    {iconFor(p.ctaType)} {p.cta}
                  </button>
                )}
              </a>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/perks"
            className="inline-flex items-center gap-2 text-[#edbb23] font-extrabold hover:gap-3 transition-all"
          >
            Learn more about our perks <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PromoBanners;
